import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

const LABEL = {
  loan_created: "Loan created", loan_edited: "Loan edited", payment_recorded: "Payment recorded", payment_edited: "Payment edited",
  payment_voided: "Payment voided", fee_waived: "Late fee waived", statement_generated: "Statement generated", statement_emailed: "Statement emailed",
  payoff_letter: "Payoff letter generated", pay_link_email: "Pay link emailed",
  certificate_issued: "Paid-in-full certificate issued", certificate_revoked: "Certificate revoked — loan reopened",
  certificate_email: "Certificate emailed", payoff_letter_email: "Payoff letter emailed",
};

const fmt = (v) => (v === null || v === undefined || v === "" ? "—" : String(v));

export const ActivityLog = ({ loanId, refreshKey }) => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get(`/loans/${loanId}/activity`).then((r) => setItems(r.data.items)); }, [loanId, refreshKey]);
  if (!items) return <div className="px-6 py-10 text-sm text-muted-foreground">Loading…</div>;
  if (!items.length) return <div className="px-6 py-12 text-center text-sm text-muted-foreground">No activity yet.</div>;
  return (
    <ul className="divide-y" data-testid="activity-log">
      {items.map((a, i) => (
        <li key={i} className="px-6 py-3.5" data-testid={`activity-${i}`}>
          <div className="flex flex-wrap items-baseline justify-between gap-2">
            <span className="text-sm font-semibold">{LABEL[a.action] || a.action}</span>
            <span className="num text-xs text-muted-foreground" data-testid={`activity-actor-${i}`}>{fmtDateTime(a.at)} ET · {a.actor_name ? `${a.actor_name} (${a.actor})` : a.actor}</span>
          </div>
          {a.changes?.length ? (
            <ul className="mt-1 space-y-0.5 text-xs text-muted-foreground">
              {a.changes.map((c, j) => <li key={j}><span className="mono">{c.field}</span>: {fmt(c.from)} → <b className="text-foreground">{fmt(c.to)}</b></li>)}
            </ul>
          ) : a.details && <div className="mt-1 text-xs text-muted-foreground">{a.details}</div>}
        </li>
      ))}
    </ul>
  );
};
